import { useEffect } from 'react';

const TikTokCallback = () => {
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const code = urlParams.get('code');
    const state = urlParams.get('state');
    
    if (code && window.opener) {
      window.opener.postMessage({ 
        type: 'tiktok-auth', 
        code,
        state
      }, window.location.origin);
      window.close();
    }
  }, []);

  return null;
};

export default TikTokCallback;